import React, { useCallback, useMemo, useState, useRef  } from 'react';
import clsx from 'clsx';
import styled from 'styled-components'
import { Container } from 'reactstrap';

import { useEditorState } from '../editor-context';
import { TratoFormatContainer, LegacyTratoFormatPreview } from './TratoFormat';
import { PdfFormat } from './PdfFormat';
import { WordFormat } from './WordFormat';
import TratoLoader from 'components/Shared/TratoLoader';



const StyledContainer = styled(Container)`
    min-height: 100%;
`

function Canvas() {
    const { document: doc, documentType, status, isMigrating } = useEditorState();
    
    return (
        <StyledContainer fluid className={clsx('px-0 d-flex align-items-center justify-content-center',  { 'py-4': documentType !== 'word'  })}>
            {/* <div className={clsx("align-items-center", )} style={{minHeight: '100%'}}> */}
            {   
                status === 'loading' || isMigrating ?  <Loader />
                : status === 'success' && !doc.isMigrated && documentType === 'trato' ? <LegacyTratoFormatPreview  />
                : documentType === 'pdf' ? <PdfFormat />
                : documentType === 'word' ? <WordFormat />
                : <TratoFormatContainer />
            }
            {/* </div> */}
        </StyledContainer>
    )
}

export default Canvas;

function Loader() {
    return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <TratoLoader className="rounded-circle" size="xl" />
        </div>
    )
}
